import script from "./VehicleLookupCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./VehicleLookupCard.vue?vue&type=script&setup=true&lang=ts"

import "./VehicleLookupCard.vue?vue&type=style&index=0&id=15a0b4b1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15a0b4b1"]])

export default __exports__